/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CanLoginByEmailInput = {|
  email: string,
  clientMutationId?: ?string,
|};
export type loginContextualCanLoginByEmailMutationVariables = {|
  input: CanLoginByEmailInput
|};
export type loginContextualCanLoginByEmailMutationResponse = {|
  +canLoginByEmail: ?{|
    +result: boolean
  |}
|};
export type loginContextualCanLoginByEmailMutation = {|
  variables: loginContextualCanLoginByEmailMutationVariables,
  response: loginContextualCanLoginByEmailMutationResponse,
|};
*/


/*
mutation loginContextualCanLoginByEmailMutation(
  $input: CanLoginByEmailInput!
) {
  canLoginByEmail(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CanLoginByEmailPayload",
    "kind": "LinkedField",
    "name": "canLoginByEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "loginContextualCanLoginByEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "loginContextualCanLoginByEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc740b4ad62f8408721c1cccc4ba6866",
    "id": null,
    "metadata": {},
    "name": "loginContextualCanLoginByEmailMutation",
    "operationKind": "mutation",
    "text": "mutation loginContextualCanLoginByEmailMutation(\n  $input: CanLoginByEmailInput!\n) {\n  canLoginByEmail(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1b7850f05f2c3b5143f5a29ad48b231b';

export default node;
